import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allMappingsAction } from '../../redux/actions/upcScanActions';
import Loader from '../loader/loader';
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import MappingButtons from './MappingButtons';

const MappingList = ({ validateBarcode }) => {


    const dispatch = useDispatch()

    const [parent_barcode, setParent_barcode] = useState("");
    const [child_barcode, setChild_barcode] = useState("");
    const { loading, mappings } = useSelector(state => state.myMappings)
    const { message } = useSelector(state => state.mapping)


    useEffect(() => {

        const query = {}

        if (parent_barcode) query.parent_barcode = parent_barcode
        if (child_barcode) query.child_barcode = child_barcode


        dispatch(allMappingsAction(query));
    }, [dispatch, parent_barcode, child_barcode, message]);




    return (
        <Fragment>
            {loading && <Loader />}
            <section className="pl-[1.5vmax] pr-[1.5vmax_2vmax] mt-[1vmax] mb-[4vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    <h2 className="text-[1.5vmax] font-2 font-bold py-[1vmax]" > Barcode Mapping List</h2>
                    <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr] gap-[1.5vmax]">

                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">
                            <input
                                type="text"
                                value={parent_barcode}
                                onChange={(e) => setParent_barcode(e.target.value)}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='Search by Case Barcode'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-[var(--color-4)] text-[2vmax] lg:text-[1.1vmax]">
                                <i className="fa-solid fa-magnifying-glass "></i>
                            </div>
                        </div>

                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">
                            <input
                                type="text"
                                value={child_barcode}
                                onChange={(e) => setChild_barcode(e.target.value)}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='Search by Item Barcode'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-[var(--color-4)] text-[2vmax] lg:text-[1.1vmax]">
                                <i className="fa-solid fa-magnifying-glass "></i>
                            </div>
                        </div>
                    </div>
                    <div className=" grid grid-cols-[0.5fr_1.2fr_0.8fr_1.2fr_1fr_1fr] mt-[2vmax] bg-gray-100 py-[0.5vmax] rounded-2xl">
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] text-center">No.</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] ">Case Barcode</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] text-center">Unit/Case</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax]">Item Barcode</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax]">Date Created</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] text-center">Action</div>
                    </div>
                    {mappings?.length > 0 ? (
                        mappings?.map((mapping, index) => (
                            <div key={index} className=" grid grid-cols-[0.5fr_1.2fr_0.8fr_1.2fr_1fr_1fr]  py-[0.8vmax] rounded-2xl">
                                <div className="text-[0.9vmax] font-2  px-[1vmax] text-center">{mappings.length - index}</div>
                                <div className="text-[0.9vmax] font-2  px-[1vmax] ">{mapping.parent_barcode}</div>
                                <div className="text-[0.9vmax] font-2  px-[1vmax] text-center">{mapping.unit_case}</div>
                                <div className="text-[0.9vmax] font-2  px-[1vmax]">{mapping.child_barcode}</div>
                                <div className="text-[0.9vmax] font-2  px-[1vmax]">{formatDbDateWithoutTime(mapping.created_at)}</div>
                                <div className="text-[0.9vmax] font-2  px-[1vmax] flex items-center justify-center gap-[1vmax]">

                                    <MappingButtons key={index} mapping={mapping} validateBarcode={validateBarcode} />
                                </div>
                            </div>
                        ))
                    )
                        :
                        <div className="text-[1.5vmax] font-2   text-center py-[1.5vmax]">No Mappings</div>

                    }

                </div>
            </section>
        </Fragment>
    )
}

export default MappingList
